import React, { useEffect, useState } from "react";
import { List } from "antd";
import "./ActivityCard.css";
import viewMoreIcon from "assets/ExportOutlined.png";
import moment from "moment";
import { getFirstNameAndInitials } from "utils/functions";

interface ActivityCardProps {
  title: string;
  link: string;
  logs: any[]; 
}

moment.updateLocale('en', {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "s",
    ss: "%ds",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1mo",
    MM: "%dmo",
    y: "1y",
    yy: "%dy"
  }
});

export const ActivityCard: React.FC<ActivityCardProps> = ({
  title,
  link,
  logs,
}) => {

  const getRelativeTime = (timestamp: string | Date): string => {
    return moment(timestamp).fromNow(true);
  };

  return (
    <div className="activity-card">
      <div className="activity-card-header">
        <h3 className="activity-card-header-title">{title}</h3>
        {/* <a className="view-more-link" href={link}>
          <img src={viewMoreIcon} alt="View more" />
        </a> */}
      </div>
      {logs.length > 0 ? (
        <List
          className="activity-card-list"
          dataSource={logs.slice(0, 5)} 
          renderItem={(log) => (
            <List.Item>
              <div className="list-data-text">
                <span className="time-text">
                  {log.timestamp ? getRelativeTime(log.timestamp) : "N/A"}
                </span>
                {log.user ? `\t${getFirstNameAndInitials(log.user)} ran` : ""}{" "}
                <span className="status-text">
                  {log.status_after || log.text || ""}
                </span>{" "}
                {log.subject && (
                  <>
                    on{" "}
                    <span className="cate-name">
                      {log.subject} L{log.level || ""} {log.content_type || ""}
                    </span>
                  </>
                )}
              </div>
            </List.Item>
          )}
        />
      ) : (
        <div>No data found</div> 
      )}
    </div>
  );
};
